import axios from "axios"
import { env } from "../constants"

/* Callback request of the partnership landing — the lead lands in the Telegram chat of the team */
export const partner = data => {
    const uri = `${env.startpoint}leads/partner`
    return axios.post(uri, data).then(response => response).catch(error => error.response)
}
